import { render } from "./GestureHints.vue?vue&type=template&id=cd99dbb2&scoped=true"
import script from "./GestureHints.vue?vue&type=script&lang=js"
export * from "./GestureHints.vue?vue&type=script&lang=js"

import "./GestureHints.vue?vue&type=style&index=0&id=cd99dbb2&scoped=true&lang=scss"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd99dbb2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
